import { AppBar, Typography, Toolbar } from "@mui/material";

import { SETTINGS_PAGE_TITLE } from "@octopus-settings/constants/ui/settingsPage";
import {
  SETTINGS_TOP_BAR_TEST_ID,
  SETTINGS_TOP_BAR_TITLE_TEST_ID,
} from "@octopus-settings/constants/testIds/settingsPage";
import useStyles from "./TopBar.styles";

const TopBar = () => {
  const { classes } = useStyles();

  return (
    <AppBar
      elevation={0}
      className={classes.appBar}
      data-testid={SETTINGS_TOP_BAR_TEST_ID}
    >
      <Toolbar disableGutters className={classes.toolbar}>
        <Typography
          variant="h5"
          component="h1"
          color="common.black"
          noWrap
          data-testid={SETTINGS_TOP_BAR_TITLE_TEST_ID}
        >
          {SETTINGS_PAGE_TITLE}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
